import React, { useState } from "react";
import {
    Box,
    Grid,
    TextField,
    Button,
    Card,
    CardContent,
    MenuItem,
} from "@mui/material";
import { useEffect } from "react";
import authService from "../Auth/AuthService";

const ROLE_TYPES = ["USER", "TEACHER", "SALES", "ACCOUNT"];

export default function EmployeeRegister({ email, mobile, loginType = 'SCHOOL', onSuccess }) {

    const [data, setData] = useState({
        email: "",
        mobile: "",
        password: "",
        roleType: "TEACHER",
        loginType: loginType,
        isActive: true,
    });

    useEffect(() => {
        if (!email || !mobile) return;

        setData((prev) => ({
            ...prev,
            email,
            mobile,
        }));
    }, [email, mobile]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!data.password) {
            alert("Password is required");
            return;
        }
        // onSubmit?.(data);
        await authService.postAuth(
            authService.pathUrl("POST", "/auth/emp/register"),
            data
        )
        if (onSuccess) onSuccess();
    };

    return (
        <Box display="flex" justifyContent="center" >
            <Card sx={{ borderRadius: 3 }}>
                <CardContent>
                    {/* <Typography variant="h5" fontWeight="bold" mb={2}>
                        Create Login
                    </Typography> */}

                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            {/* Email (readonly) */}
                            <Grid item xs={12} sm={6} width={400}>
                                <TextField
                                    label="Email"
                                    value={data.email}
                                    fullWidth
                                    disabled
                                />
                            </Grid>

                            {/* Mobile (readonly) */}
                            <Grid item xs={12} sm={6} width={400}>
                                <TextField
                                    label="Mobile"
                                    value={data.mobile}
                                    fullWidth
                                    disabled
                                />
                            </Grid>

                            {/* Password */}
                            <Grid item xs={12} sm={6} width={400}>
                                <TextField
                                    label="Password"
                                    name="password"
                                    type="password"
                                    fullWidth
                                    required
                                    value={data.password}
                                    onChange={handleChange}
                                />
                            </Grid>

                            {/* Login Type */}
                            <Grid item xs={12} sm={6} width={400}>
                                <TextField
                                    select
                                    label="Role Type"
                                    name="roleType"
                                    fullWidth
                                    value={data.roleType}
                                    onChange={handleChange}
                                >
                                    {ROLE_TYPES.map((type) => (
                                        <MenuItem key={type} value={type}>
                                            {type}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                        </Grid>
                        <Box display="flex" justifyContent="flex-end" mt={3}>
                            <Button
                                type="submit"
                                variant="contained"
                                fullWidth
                                sx={{
                                    p: 1,
                                    borderRadius: 6,
                                    backgroundColor: "#1b1914",
                                    "&:hover": { backgroundColor: "#332a14ff" },
                                }}
                            >
                                Create Account
                            </Button>
                        </Box>
                    </form>
                </CardContent>
            </Card>
        </Box >
    );
}